import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'

const STYLES = {
	payPalStyles: {
		fontFamily: 'pp-sans-big-regular',
	},
	wrapper: {
		marginTop: 30,
		marginBottom: 20,
	},
	text: {
		marginRight: 5,
		fontSize: 15,
		fontFamily: 'pp-sans-small-regular',
	}
}
class GuestPPLogIn extends React.Component {
	render () {
		const guestMessages = localsMessages('common/pPLogIn') || {}
		const havePPLabel = guestMessages.label && guestMessages.label.havePP || ''
		const logInLabel = guestMessages.label && guestMessages.label.logIn || ''

		return (
			<div className="row text-center" style={STYLES.wrapper}>
				<span style={STYLES.text}>{havePPLabel}</span>
				<a href="#" style={STYLES.payPalStyles} onClick={this.props.handleLogIn}>{logInLabel}</a>
			</div>
		);
	}
}

GuestPPLogIn.propTypes = {
	label: PropTypes.string,
	handleLogIn: PropTypes.func
};

export default GuestPPLogIn



// WEBPACK FOOTER //
// ./components/guestPPLogIn.js